/**
 * What a publish would change, for the confirm: how many routes (Site defaults counted as one) and how many languages
 * carry a changed text. Pure.
 */
import { changedRoutes, routeOf } from './seo-document';
import { SITE_DEFAULTS } from './selection';
import type { Localized, SiteSeoDocument } from './seo-types';

type Texts = Array<Localized<string> | undefined>;

const textsOf = (doc: SiteSeoDocument | null, path: string): Texts => {
  if (!doc) return [];
  if (path === SITE_DEFAULTS) return [doc.site.title_template, doc.site.description, doc.site.footer_text];
  const route = routeOf(doc, path);
  return route ? [route.title, route.description, route.footer_text] : [];
};

/** Adds every language whose value differs between the two field lists (same order) to `into`. */
const addChangedLanguages = (before: Texts, after: Texts, into: Set<string>): void => {
  const fields = Math.max(before.length, after.length);
  for (let i = 0; i < fields; i += 1) {
    const a = before[i] ?? {};
    const b = after[i] ?? {};
    for (const language of new Set([...Object.keys(a), ...Object.keys(b)])) {
      if ((a[language] ?? '') !== (b[language] ?? '')) into.add(language);
    }
  }
};

export const publishSummary = (
  draft: SiteSeoDocument,
  published: SiteSeoDocument | null,
): { routes: number; languages: number } => {
  const changed = changedRoutes(draft, published);
  const languages = new Set<string>();
  for (const path of changed) addChangedLanguages(textsOf(published, path), textsOf(draft, path), languages);
  return { routes: changed.size, languages: languages.size };
};
